// ====================================================================
// LEBENSZAHL-RECHNER - JavaScript
// ====================================================================

class LebenszahlRechner {
    constructor(containerId) {
        this.container = document.getElementById(containerId);
        this.init();
    }
    
    init() {
        this.container.innerHTML = this.getHTML();
        this.attachEventListeners();
    }
    
    getHTML() {
        return `
            <div class="rechner-wrapper">
                <div class="rechner-header">
                    <h3>🔢 Berechne deine Lebenszahl</h3>
                    <p>Gib dein Geburtsdatum ein und entdecke deine numerologische Persönlichkeitszahl</p>
                </div>
                
                <div class="rechner-input-group">
                    <label for="birthdate">Geburtsdatum</label>
                    <input 
                        type="date" 
                        id="birthdate" 
                        class="rechner-input"
                        max="${new Date().toISOString().split('T')[0]}"
                    >
                </div>
                
                <button id="calculateBtn" class="rechner-button">
                    Lebenszahl berechnen
                </button>
                
                <div id="rechner-result" class="rechner-result" style="display: none;">
                    <div class="result-animation">
                        <div class="result-number" id="resultNumber"></div>
                        <div class="result-text">
                            <h4 id="resultTitle"></h4>
                            <p id="resultDescription"></p>
                        </div>
                    </div>
                    
                    <div class="calculation-steps" id="calculationSteps"></div>
                    
                    <a href="#" id="resultLink" class="result-link">
                        → Mehr über Lebenszahl <span id="linkNumber"></span> erfahren
                    </a>
                </div>
                
                <div id="rechner-error" class="rechner-error" style="display: none;"></div>
            </div>
            
            <style>
                .rechner-wrapper {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    padding: 40px;
                    border-radius: 15px;
                    box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
                    color: #fff;
                    max-width: 600px;
                    margin: 40px auto;
                }
                
                .rechner-header h3 {
                    color: #fff;
                    margin: 0 0 10px 0;
                    font-size: 1.8rem;
                    text-align: center;
                }
                
                .rechner-header p {
                    color: #f0f0f0;
                    text-align: center;
                    margin: 0 0 30px 0;
                    font-size: 1rem;
                }
                
                .rechner-input-group {
                    margin-bottom: 25px;
                }
                
                .rechner-input-group label {
                    display: block;
                    margin-bottom: 8px;
                    font-weight: 600;
                    font-size: 1.1rem;
                }
                
                .rechner-input {
                    width: 100%;
                    padding: 15px;
                    font-size: 1.1rem;
                    border: 3px solid #fff;
                    border-radius: 10px;
                    background: rgba(255, 255, 255, 0.95);
                    color: #333;
                    transition: all 0.3s ease;
                    box-sizing: border-box;
                }
                
                .rechner-input:focus {
                    outline: none;
                    border-color: #ffd700;
                    background: #fff;
                    box-shadow: 0 0 20px rgba(255, 215, 0, 0.5);
                }
                
                .rechner-button {
                    width: 100%;
                    padding: 18px;
                    font-size: 1.3rem;
                    font-weight: 700;
                    background: #fff;
                    color: #667eea;
                    border: none;
                    border-radius: 50px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
                }
                
                .rechner-button:hover {
                    background: #ffd700;
                    color: #333;
                    transform: translateY(-3px);
                    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
                }
                
                .rechner-button:active {
                    transform: translateY(-1px);
                }
                
                .rechner-result {
                    margin-top: 30px;
                    background: rgba(255, 255, 255, 0.15);
                    padding: 30px;
                    border-radius: 15px;
                    backdrop-filter: blur(10px);
                    animation: fadeInUp 0.6s ease;
                }
                
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                .result-animation {
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    margin-bottom: 25px;
                }
                
                .result-number {
                    min-width: 100px;
                    height: 100px;
                    background: #fff;
                    color: #667eea;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 3rem;
                    font-weight: 700;
                    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
                    animation: pulse 2s infinite;
                }
                
                @keyframes pulse {
                    0%, 100% {
                        transform: scale(1);
                    }
                    50% {
                        transform: scale(1.05);
                    }
                }
                
                .result-text h4 {
                    margin: 0 0 10px 0;
                    font-size: 1.5rem;
                    color: #fff;
                }
                
                .result-text p {
                    margin: 0;
                    color: #f0f0f0;
                    font-size: 1rem;
                    line-height: 1.5;
                }
                
                .calculation-steps {
                    background: rgba(255, 255, 255, 0.1);
                    padding: 20px;
                    border-radius: 10px;
                    margin-bottom: 20px;
                    font-family: 'Courier New', monospace;
                    font-size: 1rem;
                }
                
                .calculation-steps div {
                    margin: 8px 0;
                    color: #fff;
                }
                
                .result-link {
                    display: inline-block;
                    background: #fff;
                    color: #667eea;
                    padding: 15px 30px;
                    border-radius: 50px;
                    text-decoration: none;
                    font-weight: 700;
                    font-size: 1.1rem;
                    transition: all 0.3s ease;
                    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
                }
                
                .result-link:hover {
                    background: #ffd700;
                    color: #333;
                    transform: translateY(-3px);
                    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
                }
                
                .rechner-error {
                    margin-top: 20px;
                    padding: 15px;
                    background: rgba(255, 82, 82, 0.9);
                    border-radius: 10px;
                    color: #fff;
                    font-weight: 600;
                    text-align: center;
                }
                
                @media (max-width: 768px) {
                    .rechner-wrapper {
                        padding: 25px;
                    }
                    
                    .result-animation {
                        flex-direction: column;
                        text-align: center;
                    }
                    
                    .result-number {
                        min-width: 80px;
                        height: 80px;
                        font-size: 2.5rem;
                    }
                }
            </style>
        `;
    }
    
    attachEventListeners() {
        const calculateBtn = document.getElementById('calculateBtn');
        const birthdateInput = document.getElementById('birthdate');
        
        calculateBtn.addEventListener('click', () => this.calculate());
        
        birthdateInput.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
                this.calculate();
            }
        });
    }
    
    calculate() {
        const birthdateInput = document.getElementById('birthdate');
        const birthdate = birthdateInput.value;
        
        // Validierung
        if (!birthdate) {
            this.showError('Bitte gib dein Geburtsdatum ein.');
            return;
        }
        
        // Berechnung durchführen
        const result = this.calculateLebenszahl(birthdate);
        this.showResult(result);
    }
    
    calculateLebenszahl(birthdate) {
        // Datum in einzelne Komponenten zerlegen
        const [year, month, day] = birthdate.split('-');
        
        // Alle Ziffern extrahieren
        const digits = (day + month + year).split('').map(Number);
        
        // Schritte für die Anzeige
        const steps = [];
        steps.push(`Geburtsdatum: ${day}.${month}.${year}`);
        steps.push(`Einzelne Ziffern: ${digits.join(' + ')}`);
        
        // Erste Quersumme
        let sum = digits.reduce((acc, digit) => acc + digit, 0);
        steps.push(`Erste Summe: ${digits.join(' + ')} = ${sum}`);
        
        // Auf Meisterzahlen prüfen
        if (sum === 11 || sum === 22 || sum === 33) {
            steps.push(`✨ Meisterzahl erkannt: ${sum} (wird nicht weiter reduziert)`);
            return {
                lebenszahl: sum,
                isMeisterzahl: true,
                steps: steps
            };
        }
        
        // Weitere Reduktion falls nötig
        while (sum > 9) {
            const oldSum = sum;
            const newDigits = sum.toString().split('').map(Number);
            sum = newDigits.reduce((acc, digit) => acc + digit, 0);
            steps.push(`${oldSum} → ${newDigits.join(' + ')} = ${sum}`);
            
            // Meisterzahl-Check nach jeder Reduktion
            if (sum === 11 || sum === 22 || sum === 33) {
                steps.push(`✨ Meisterzahl erkannt: ${sum} (wird nicht weiter reduziert)`);
                return {
                    lebenszahl: sum,
                    isMeisterzahl: true,
                    steps: steps
                };
            }
        }
        
        steps.push(`→ Deine Lebenszahl ist: ${sum}`);
        
        return {
            lebenszahl: sum,
            isMeisterzahl: false,
            steps: steps
        };
    }
    
    showResult(result) {
        const resultDiv = document.getElementById('rechner-result');
        const errorDiv = document.getElementById('rechner-error');
        const resultNumber = document.getElementById('resultNumber');
        const resultTitle = document.getElementById('resultTitle');
        const resultDescription = document.getElementById('resultDescription');
        const calculationSteps = document.getElementById('calculationSteps');
        const resultLink = document.getElementById('resultLink');
        const linkNumber = document.getElementById('linkNumber');
        
        // Error verstecken
        errorDiv.style.display = 'none';
        
        // Lebenszahl-Infos
        const info = this.getLebenszahlInfo(result.lebenszahl);
        
        // Ergebnis anzeigen
        resultNumber.textContent = result.lebenszahl;
        resultTitle.textContent = info.title;
        resultDescription.textContent = info.description;
        
        // Berechnungsschritte
        calculationSteps.innerHTML = result.steps.map(step => 
            `<div>${step}</div>`
        ).join('');
        
        // Link zur Detail-Seite (anpassbar)
        linkNumber.textContent = result.lebenszahl;
        resultLink.href = `#lebenszahl-${result.lebenszahl}`;
        
        // Spezielle Farbe für Meisterzahlen
        if (result.isMeisterzahl) {
            resultNumber.style.background = 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)';
            resultNumber.style.color = '#fff';
        } else {
            resultNumber.style.background = '#fff';
            resultNumber.style.color = '#667eea';
        }
        
        // Anzeigen mit Animation
        resultDiv.style.display = 'block';
        
        // Smooth Scroll zum Ergebnis
        setTimeout(() => {
            resultDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 100);
    }
    
    showError(message) {
        const resultDiv = document.getElementById('rechner-result');
        const errorDiv = document.getElementById('rechner-error');
        
        resultDiv.style.display = 'none';
        errorDiv.textContent = message;
        errorDiv.style.display = 'block';
    }
    
    getLebenszahlInfo(number) {
        const infos = {
            1: {
                title: 'Lebenszahl 1 – Der Pionier und Anführer',
                description: 'Du bist eine geborene Führungspersönlichkeit mit starkem Willen, Durchsetzungskraft und dem Mut, neue Wege zu gehen.'
            },
            2: {
                title: 'Lebenszahl 2 – Der Diplomat und Vermittler',
                description: 'Du stehst für Harmonie, Partnerschaft und Sensibilität. Du bist empathisch, kooperativ und hast ein starkes Bedürfnis nach zwischenmenschlicher Verbindung.'
            },
            3: {
                title: 'Lebenszahl 3 – Der Kreative und Kommunikator',
                description: 'Du repräsentierst Kreativität, Ausdruck und Lebensfreude. Du bist kommunikativ, optimistisch und hast die natürliche Begabung, andere zu inspirieren.'
            },
            4: {
                title: 'Lebenszahl 4 – Der Baumeister und Strukturgeber',
                description: 'Du stehst für Stabilität, Ordnung und harte Arbeit. Du bist zuverlässig, praktisch veranlagt und hast einen ausgeprägten Sinn für Struktur.'
            },
            5: {
                title: 'Lebenszahl 5 – Der Freigeist und Abenteurer',
                description: 'Du symbolisierst Freiheit, Veränderung und Abenteuer. Du bist wissbegierig, anpassungsfähig und liebst Vielfalt und neue Erfahrungen.'
            },
            6: {
                title: 'Lebenszahl 6 – Der Fürsorger und Harmonisierer',
                description: 'Du stehst für Verantwortung, Fürsorge und Familie. Du hast ein tiefes Bedürfnis, anderen zu helfen und Harmonie zu schaffen.'
            },
            7: {
                title: 'Lebenszahl 7 – Der Mystiker und Denker',
                description: 'Du bist die Zahl der Spiritualität, Analyse und Innenschau. Du bist ein tiefgründiger Denker, der nach Wahrheit und tieferem Verständnis sucht.'
            },
            8: {
                title: 'Lebenszahl 8 – Der Macher und Manifestor',
                description: 'Du stehst für Macht, Erfolg und materielle Fülle. Du bist ambitioniert, zielorientiert und hast die natürliche Fähigkeit, Dinge zu manifestieren.'
            },
            9: {
                title: 'Lebenszahl 9 – Der Weise und Vollender',
                description: 'Du repräsentierst Vollendung, Weisheit und universelle Liebe. Du bist altruistisch, mitfühlend und hast eine globale Perspektive.'
            },
            11: {
                title: 'Lebenszahl 11 – Die Meisterzahl der Intuition ✨',
                description: 'Du trägst eine besonders spirituelle Energie. Du hast aussergewöhnliche intuitive Fähigkeiten und eine starke spirituelle Mission.'
            },
            22: {
                title: 'Lebenszahl 22 – Die Meisterzahl der Manifestation ✨',
                description: 'Du bist die "Meisterbaumeisterin". Du hast das Potenzial, grosse Träume in die Realität umzusetzen und bleibende Strukturen zu schaffen.'
            },
            33: {
                title: 'Lebenszahl 33 – Die Meisterzahl der universellen Liebe ✨',
                description: 'Du trägst die höchste Meisterzahl und bist ein "Meisterlehrer". Deine Mission ist bedingungslose Liebe, Heilung und Dienst an anderen.'
            }
        };
        
        return infos[number] || {
            title: 'Lebenszahl ' + number,
            description: 'Entdecke die Bedeutung deiner Lebenszahl!'
        };
    }
}

// ====================================================================
// INITIALISIERUNG
// ====================================================================

// Automatische Initialisierung wenn DOM geladen ist
document.addEventListener('DOMContentLoaded', function() {
    // Suche nach dem Container
    const rechnerContainer = document.getElementById('lebenszahl-rechner');
    
    if (rechnerContainer) {
        new LebenszahlRechner('lebenszahl-rechner');
    }
});

// Alternativ: Manuelle Initialisierung möglich
// const rechner = new LebenszahlRechner('lebenszahl-rechner');